import React, { FC, useEffect, useRef, useState } from 'react';


export interface VideoComponentProps {
  src: string;
  fallbackImage: string;
}

const VideoComponent: FC<VideoComponentProps> = ({ src, fallbackImage }): JSX.Element => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [canPlayWebm, setCanPlayWebm] = useState<boolean>(true); // TODO

  useEffect(() => {
    if (src && videoRef.current) {
      const check = videoRef.current.canPlayType('video/webm; codecs="vp8, vorbis"');
      setCanPlayWebm(check === 'probably');
    }
  }, [src, videoRef])

  return (
    <>
      {canPlayWebm
        ? (<video
          ref={videoRef}
          src={src}
          autoPlay={true}
          loop={true}
          controls={false}
          muted={true}
          width="100%"
        />)
        : (<img
            className="fallback-image"
            src={fallbackImage}
            alt="fallback"
          />)
      }
    </>
  );
};

export default VideoComponent;